import React from 'react';
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { Input } from 'antd';
import './FormInputs.scss';
import { EditedIcon } from '../../assets/Icons/EditedIcon';
import { DeletedIcon } from '../../assets/Icons/DeletedIcon';

const FormInputs = ({
  title,
  type,
  value,
  onChange,
  name,
  placeholder,
  onKeyDown,
  error,
  rows,
  maxLength,
  minLength,
  showPasswordToggle,
  showEditIcon,
  showDeleteIcon,
  onEdit,
  onDelete,
  style,
  inputRef,
  prefix,
  ...props
}) => {
  const InputComponent = type === 'password' ? Input.Password : rows ? Input.TextArea : Input;

  return (
    <div className="forminput">
      <div className="forminput_header">
        <span className="forminput_title">{title}</span>
        <div className="forminput_icons">
          {showEditIcon && <EditedIcon onClick={onEdit} />}
          {showDeleteIcon && <DeletedIcon onClick={onDelete} />}
        </div>
      </div>
      <div className="input-container">
        <InputComponent
          ref={inputRef}
          className="input"
          onKeyDown={onKeyDown}
          type={type === 'password' ? 'password' : 'text'}
          name={name}
          rows={rows}
          value={value}
          style={style}
          onChange={onChange}
          placeholder={placeholder}
          maxLength={maxLength}
          minLength={minLength}
          prefix={prefix}
          iconRender={
            type === 'password' && showPasswordToggle
              ? (visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)
              : undefined
          }
          visibilityToggle={
            type === 'password' && showPasswordToggle
              ? { visible: true, onVisibleChange: () => {} }
              : undefined
          }
          {...props}
        />
        <span className="error">{error}</span>
      </div>
    </div>
  );
};

export default FormInputs;
